import React, { createContext, useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import { MENU } from '@queries';
import { Menu } from '@src/queries/__generated__/Menu';

import useIsComDomain from '@src/hooks/useIsComDomain';
import { parsingCategoryData } from '@src/utils';

const MenuDataContext = createContext(null);

const MenuDataProvider = ({ children }) => {
  const isComDomain = useIsComDomain();

  // Header data
  const [categoryItems, setCategoryItems] = useState([]);
  const [MGSBtnUrl, setMGSBtnUrl] = useState();
  const [saleBtnUrl, setSaleBtnUrl] = useState();

  // Footer data
  const [aboutItems, setAboutItems] = useState([]);
  const [supportItems, setSupportItems] = useState([]);
  const [contactsItems, setContactsItems] = useState([]);

  const [getHeaderData] = useLazyQuery<Menu>(MENU, {
    variables: { name: 'navbar' },
    onCompleted: (data) => {
      const parsedJsonContent = JSON.parse(data?.menu?.jsonContent);

      const categoryData = parsedJsonContent.find((content) => content.name === 'CATEGORIES')?.child_items;
      const brandData = parsedJsonContent.find((content) => content.name === 'BRANDS')?.child_items;
      const MGSData = parsedJsonContent.find((content) => content.name === 'MGS');
      const offerData = parsedJsonContent.find((content) => content.name === 'OFFERS');

      // store category Data in local Storage
      const processedData = parsingCategoryData(categoryData);
      localStorage.setItem('category-navbar', JSON.stringify(processedData));
      localStorage.setItem('brand-list', JSON.stringify(brandData));

      setCategoryItems(categoryData || []);
      setMGSBtnUrl(MGSData?.url);
      setSaleBtnUrl(offerData?.url);
    },
  });

  const [getFooterData] = useLazyQuery<Menu>(MENU, {
    variables: { name: 'footer' },
    onCompleted: (data) => {
      const parsedJsonContent = JSON.parse(data?.menu?.jsonContent);

      setAboutItems(parsedJsonContent.find((content) => content.name === 'about')?.child_items || []);

      if (isComDomain) {
        setSupportItems(parsedJsonContent.find((content) => content.name === 'support-com')?.child_items || []);
        setContactsItems(parsedJsonContent.find((content) => content.name === 'contacts-com')?.child_items || []);
      } else {
        setSupportItems(parsedJsonContent.find((content) => content.name === 'support')?.child_items || []);
        setContactsItems(parsedJsonContent.find((content) => content.name === 'contacts')?.child_items || []);
      }
    },
  });

  useEffect(() => {
    getHeaderData();
    getFooterData();
  }, []);

  return (
    <MenuDataContext.Provider
      value={{
        categoryItems,
        MGSBtnUrl,
        saleBtnUrl,
        aboutItems,
        supportItems,
        contactsItems,
      }}
    >
      {children}
    </MenuDataContext.Provider>
  );
};

export { MenuDataContext, MenuDataProvider };
